import { CountryCodeToDialCode } from "./country-iso-code-to-dial-code";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";
import { cleanupPhoneNumber } from "./cleanup-phone-number";
import { DialCodeToCountryIsoCode } from "./dial-code-to-country-iso-code";

export type InternationalPhoneNumber = {
  countryIsoCode: string;
  localPhoneNumber: string;
};

export const InternationalPhoneNumber = {
  toString: (p: InternationalPhoneNumber, countryIsoCode: string): string => {
    const dialCode =
      CountryCodeToDialCode[p.countryIsoCode.toUpperCase()] ?? CountryCodeToDialCode[countryIsoCode.toUpperCase()]!;

    return `${dialCode} ${cleanupPhoneNumber(p.localPhoneNumber)}`;
  },
  fromString: (
    internationalPhoneNumber: string,
    localeCountryIsoCode: string,
  ): InternationalPhoneNumber | undefined => {
    const [dialCode, localPhoneNumber] = internationalPhoneNumber.split(" ");

    if (typeof dialCode === "string" && typeof localPhoneNumber === "string") {
      const countryIsoCode =
        DialCodeToCountryIsoCode[dialCode] ?? DialCodeToCountryIsoCode[localeCountryIsoCode.toUpperCase()]!;

      return { countryIsoCode, localPhoneNumber };
    } else {
      return undefined;
    }
  },
};
